<template>
  <label class="agc-label" :for="id">
    <slot></slot>
    <span v-if="required" class="agc-label__required">*</span>
    <span class="agc-label__sub">
      &nbsp;<slot name="subLabel"></slot>
    </span>
  </label>
</template>

<script>
export default {
  props: {
    id: {
      type: [Number, String],
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    subLabel: {
      type: String,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.agc-label {
  font-size: 0.94rem;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 21px;
  margin-bottom: 0.625rem;
  color: #3A4047;

  &__required {
    color: #f54b4e;
  }

  &__sub {
    color: #7e8b97;
    font-size: 0.88rem;
    letter-spacing: 0;
    line-height: 18px;
    align-self: end;
  }
  h4 {
    padding-bottom: 0 !important;
  }
}

@include respond(tab-landscape) {
  .agc-label__sub {
    display: flex;
    flex-flow: wrap;
  }

}
</style>
